import React from 'react';
import Section from '../../../../components/Section';
import FormView from '../../../../templates/FormView';
import GridInput from '../../../../components/form/GridInput';
import GridMultifield from '../../../../components/form/GridMultifield';
import Avatar from '../../../formando/DetailsView/RegistrationData/Avatar';
import { isValidCEP } from '../../../../core/validations';
import { stringToData } from '../../../../core/util';
import GeneralInfo from './GeneralInfo';
import validator from '../validator';

import withWidth from '../../../../components/useWidth';

function ConfirmationForm(props) {
  const {
    view,
    width,
    combos,
    communicating,
    submitProfile,
    setAvatar,
    invalidateCache,
    fetchStudentByCpf,
    fetchAddressByCep,
    currentOrganizationID,
  } = props;
  const formViewProps = {
    submit: submitProfile,
    communicating,
    title: 'Cadastro',
    subtitle: 'Confirmação de Cadastro',
    invalidateCache: () => invalidateCache(props),
    hideCleanButton: true,
    hideReturnButton: true,
    hideToggleMenuButton: true,
    formProps: {
      view,
      validator,
      disabled: communicating,
    },
  };

  return (
    <FormView {...formViewProps}>
      <Section title="Informações Gerais" direction="row-reverse">
        <Section subsection md={4}>
          <GridInput
            name="avatar"
            label="Avatar"
            type="file"
            sendAvatarToDB={setAvatar}
            width={width}
            component={Avatar}
          />
        </Section>
        <Section subsection md={8}>
          <GeneralInfo
            view={view}
            combos={combos}
            org={currentOrganizationID}
            fetchStudentByCpf={fetchStudentByCpf}
          />
        </Section>
      </Section>

      <Section title="Senha">
        <Section subsection md={8}>
          <GridInput
            name="senha"
            label="Crie sua senha"
            type="password"
            md={6}
            lg={4}
            required
          />
          <GridInput
            name="confirmacao"
            label="Confirmação de Senha"
            type="password"
            md={6}
            lg={4}
            required
          />
        </Section>
        <Section subsection md={4} />
      </Section>

      <Section title="Endereço">
        <Section subsection md={8}>
          <GridInput
            name="cep"
            label="CEP"
            type="cep"
            lg={8}
            required
            onChange={(e) => {
              const cep = e.target.value;
              if (cep && isValidCEP(stringToData('cep', cep))) {
                fetchAddressByCep(`${cep}`, view);
              }
            }}
          />
          <GridInput name="endereco" label="Logradouro" lg={8} disabled />
          <GridInput name="bairro" label="Bairro" md={6} lg={4} disabled />
          <GridInput name="numero" label="Número" md={6} lg={4} required />
          <GridInput name="cidade" label="Cidade" md={6} lg={4} disabled />
          <GridInput name="estado" label="Estado" md={6} lg={4} disabled />
          <GridInput name="indEndCorreto" xs={12} style={{ display: 'none' }} />
          <GridInput name="complemento" label="Complemento" />
        </Section>
        <Section subsection md={4} />
      </Section>

      <Section title="Contato">
        <Section subsection md={8}>
          <GridMultifield
            name="telefones"
            fields={[
              {
                name: 'tipo',
                label: 'Tipo',
                type: 'select',
                options: combos.phoneTypes,
              },
              {
                name: 'telefone',
                label: 'Telefone',
                type: 'phone',
              },
            ]}
          />
        </Section>
      </Section>
      <Section subsection md={4} />
    </FormView>
  );
}

export default withWidth()(ConfirmationForm);
